import { Box } from '@mui/material';
import { FC, ReactNode, useEffect } from 'react';
import { Outlet } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SideBar from './SideBar';
import useAuth from 'store/Auth/useAuth';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ToastSuccessIcon } from 'atoms/icons/svg/icon-check.svg';
import { ReactComponent as ToastInfoIcon } from 'atoms/icons/svg/icon-info.svg';
import { ReactComponent as ToastErrorIcon } from 'atoms/icons/svg/icon-error.svg';
import { ReactComponent as ToastWarningIcon } from 'atoms/icons/svg/icon-warning.svg';
import { ReactComponent as ToastCrossIcon } from 'atoms/icons/svg/toast-cross.svg';

interface GuestProps {
  children?: ReactNode;
}

const PrivateLayout: FC<GuestProps> = ({ children }) => {
  const { profile, isCustomer } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (profile?.language) {
      window.localStorage.setItem('Language', profile?.language);
      i18n.changeLanguage(profile?.language ?? 'en');
    }
  }, [profile?.language]);

  useEffect(() => {
    if (!isCustomer) return;

    const envLabel = process.env.REACT_APP_ENV_LABEL;
    const baseTitle = 'Remora Insight App';
    const fullTitle = envLabel ? `[${envLabel}] ${baseTitle}` : baseTitle;

    document.title = fullTitle;
  }, [isCustomer]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        height: 'auto',
      }}
    >
      <SideBar>
        {children || <Outlet />}
        <ToastContainer
          position="bottom-right"
          closeButton={({ closeToast }) => (
            <span className="toast-cross">
              <span className="divider" />

              <button className="toast-close-btn" onClick={closeToast}>
                <ToastCrossIcon />
              </button>
            </span>
          )}
          toastClassName="custom-toast-style"
          icon={({ type }) => {
            if (type === 'success') {
              return <ToastSuccessIcon />;
            }
            if (type === 'info') {
              return <ToastInfoIcon />;
            }
            if (type === 'error') {
              return <ToastErrorIcon />;
            }
            if (type === 'warning') {
              return <ToastWarningIcon />;
            }
            return undefined;
          }}
        />
      </SideBar>
    </Box>
  );
};

export default PrivateLayout;
